/**
 * OEP platform surface module for MJExplorer: the BaseDashboard host MJ's shell instantiates via
 * the 'FeedbackPlatformAppSurface' driver class, the shared chrome, and the per-surface services.
 * No second GraphQL client — every call goes through MJ's configured provider (RunView,
 * BaseEntity, GraphQLDataProvider.ExecuteGQL). Views and overlays are added by T24–T30 (T30: Resources, the tour, the email-templates panel).
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MJButtonDirective, MJEmptyStateComponent, MJPageSearchComponent, MJStatBadgeComponent, MJTabNavComponent, MjSlidePanelComponent } from '@memberjunction/ng-ui-components';
import { AGUAppShellModule, AGUSurfaceReadyService } from 'agu_app_shell';
import { LoadOEPEntityRules } from 'agu_oep_core';
import { LoadOEPSurface, OEPSurfaceComponent } from './oep-surface.component';
import { OEPHeaderComponent } from './chrome/oep-header.component';
import { OEPNotificationsComponent } from './chrome/oep-notifications.component';
import { OEPRoleChipComponent } from './chrome/oep-role-chip.component';
import { OEPHomeComponent } from './views/home/oep-home.component';
import { OEPPresentationComponent } from './views/presentation/oep-presentation.component';
import { OEPReviewsComponent } from './views/reviews/oep-reviews.component';
import { OEPReviewComponent } from './views/review/oep-review.component';
import { OEPNominateComponent } from './views/nominate/oep-nominate.component';
import { OEPNominationComponent } from './views/nomination/oep-nomination.component';
import { OEPCommitteeComponent } from './views/committee/oep-committee.component';
import { OEPProgramStatusComponent } from './views/program-status/oep-program-status.component';
import { OEPActivityComponent } from './views/activity/oep-activity.component';
import { OEPUserManagementComponent } from './views/user-management/oep-user-management.component';
import { OEPResourcesComponent } from './views/resources/oep-resources.component';
import { OEPTourComponent } from './overlays/oep-tour.component';
import { OEPEmailsComponent } from './overlays/oep-emails.component';

@NgModule({
    declarations: [OEPSurfaceComponent, OEPHeaderComponent, OEPNotificationsComponent, OEPRoleChipComponent, OEPHomeComponent, OEPPresentationComponent, OEPReviewsComponent, OEPReviewComponent, OEPNominateComponent, OEPNominationComponent, OEPCommitteeComponent, OEPProgramStatusComponent, OEPActivityComponent, OEPUserManagementComponent, OEPResourcesComponent, OEPTourComponent, OEPEmailsComponent],
    imports: [CommonModule, FormsModule, AGUAppShellModule, MJButtonDirective, MJEmptyStateComponent, MJPageSearchComponent, MJStatBadgeComponent, MJTabNavComponent, MjSlidePanelComponent],
    // Stateless readiness gate only; everything per-surface is provided by OEPSurfaceComponent (see its providers note).
    providers: [AGUSurfaceReadyService],
})
export class OEPSurfaceModule {
    constructor() {
        LoadOEPSurface();
        // Registers agu_oep_core's validating entity subclasses client-side (Validate/ValidateAsync
        // for immediate feedback on Save); the server re-runs the same rules.
        LoadOEPEntityRules();
    }
}
